/*

This is probably good a place as any to explain the paypal workflow.

If someone pays with paypal, obviously they don't pay on okcupid.com; they have to
go to a paypal page and enter their credit card and stuff.

So that means we need to redirect people to paypal, and paypal needs to know where
to redirect them back.

So this is the series of steps:

1. We use the fetchPaypalLink action to get the paypal link.
2. Inside the service call, getPaypalLink, it generates a callback link (getPaypalCallbacks).
it's basically the current page they're on, with querystring params and all, plus more
querystring params of everything we need to resume their session:
productid, platform, country, etc.
3. When the user clicks on the "continue to paypal" button, they go to paypal.
4. When they're finished, paypal makes the user visit the callback link. They also add
a transaction token to the querystring.
5. in src/apps/payment/containers/Payment, on component mount, we check the querystring
6. if `paypalsuccess` is present, throw some actions that set the UI to the paypal page.
(Side note, note that the app at the same time will be fetching the product info with the
productid from CGI.)
7. Also, at the same time, we're calling the confirmPurchasePaypal action so the
backend can take that token and exchange it for the user's sweet loot.

Okay I hope that helps / saves you from a few minutes of reading / opening files / etc.

*/

import React, { Component } from "react";
import PropTypes from "prop-types";

import PurchaseButton from "apps/payment/components/PurchaseButton";
import ErrorBlock from "apps/payment/components/ErrorBlock";

import Str from "shared/components/Str";

import { CREDIT_FORM_NAMES, PAYPAL_PAYMENT_PROCESSOR } from "shared/payment/constants";

import "./PayPalPurchase.scss";

export class PayPalPurchase extends Component {
	static propTypes = {
		startPurchase: PropTypes.func.isRequired,
		fetchPaypalLink: PropTypes.func.isRequired,
		paypalLink: PropTypes.string,
		userInfo: PropTypes.shape({
			state: PropTypes.string,
		}).isRequired,
		product: PropTypes.object,
		isSuccessful: PropTypes.bool.isRequired,
		isPurchasing: PropTypes.bool.isRequired,
		isEditingInfo: PropTypes.bool.isRequired,
		errorMessage: PropTypes.object.isRequired,
		isSettingPayPalLink: PropTypes.bool.isRequired,
	};

	static defaultProps = {
		paypalLink: "",
		product: {},
	};

	state = {
		isRedirecting: false,
	};

	componentDidMount() {
		if (!this.props.paypalLink) {
			this.props.fetchPaypalLink();
		}
	}

	render() {
		const {
			isSuccessful,
			isPurchasing,
			isEditingInfo,
			userInfo,
			product,
			errorMessage,
		} = this.props;

		return (
			<form
				className="payment-paypal-purchase"
				onSubmit={(ev) => {
					ev.preventDefault();
					ev.stopPropagation();

					if (
						!this.props.isPurchasing && !this.props.isSuccessful &&
						!this.props.isSettingPayPalLink && this.props.paypalLink
					) {
						// fire transaction call only if they're purchasing
						if (!this.props.isEditingInfo) {
							this.props.startPurchase({
								product,
								method: PAYPAL_PAYMENT_PROCESSOR,
								existingInfo: false,
							});
						}

						this.setState({ isRedirecting: true });
						window.location.href = this.props.paypalLink;
					}
				}}
			>
				<div className="payment-paypal-purchase-logo" />

				<ErrorBlock
					message={errorMessage[CREDIT_FORM_NAMES.paypalPurchaseScreen]}
				/>

				<PurchaseButton
					isSuccessful={isSuccessful}
					isPurchasing={isPurchasing}
					isEditingInfo={isEditingInfo}
					state={userInfo.state}
					willRedirect={true}
					isRedirecting={this.state.isRedirecting}
				>
					<div className="payment-credit-purchase-security">
						<a
							rel="noopener noreferrer"
							target="_blank"
							href="https://www.paypal.com/cgi-bin/webscr?cmd=xpt/Marketing/popup/OLCWhatIsPayPal-outside"
							className="payment-paypal-purchase-what-is-paypal"
						>
							<Str>What is PayPal?</Str>
						</a>
					</div>
				</PurchaseButton>
			</form>
		);
	}
}

export default PayPalPurchase;



// WEBPACK FOOTER //
// ./src/apps/payment/components/PayPalPurchase/index.jsx